// Abonnement.jsx
import React from "react";
import SubscriptionPlans from "./SubscriptionPlans";

const Abonnement = () => {

  const token = localStorage.getItem("authTokenUtilisateur");

  return (
    <div className="flex flex-col gap-6 py-4 min-h-screen px-6">
      <h1 className="font-bold text-4xl text-color1 mb-6">Abonnement</h1>

      {/* Affichage des plans */}
      <SubscriptionPlans token={token} />
    </div>
  );
};

export default Abonnement;
